import * as React from 'react'
import {
  ButtonOLD,
  HeaderSection,
  Icon,
  IconType,
  Popover,
  Text,
  Heading,
} from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import Glyph from '../../../../LEGACY/Glyph'
import styled from 'styled-components'

import { FC } from 'react'
import { ProTag } from 'components/ProTag'

type Props = {
  handleToggleModal: () => void
  allowCreateEditTemplates: boolean
}

const StyledHeading = styled(Heading)`
  font-size: 16px;
  font-weight: 500;
`

const StyledLink = styled(Heading)`
  font-size: 16px;
  font-weight: 500;
  margin-left: 5px;
`

export const SkillNeedTemplateHeaderSection: FC<Props> = ({
  handleToggleModal,
  allowCreateEditTemplates,
}) => {
  const { t } = useTranslation()

  const renderButton = (
    <div>
      <ButtonOLD
        disabled={!allowCreateEditTemplates}
        icon={
          <Glyph
            name="plus"
            aphroditeStyles={undefined}
            className={undefined}
            color={undefined}
            component={undefined}
            size={undefined}
            style={undefined}
          />
        }
        type="primary"
        onClick={handleToggleModal}
      >
        {t(`skillsAndNeeds.addNewSkill`)}
      </ButtonOLD>
    </div>
  )

  return (
    <HeaderSection
      title={
        <div style={styles.flex}>
          {t('skillsAndNeeds.templateTitle')}
          <ProTag />
        </div>
      }
      iconColor="#EFEEFF"
      iconContent={
        <Icon customIcon={IconType.LogoPurple} style={styles.logoIcon} />
      }
      rightChildren={
        !allowCreateEditTemplates ? (
          <Popover
            placement="bottomRight"
            content={
              <div style={styles.linkWrapper as React.CSSProperties}>
                <Text level={5}>{t('skillsAndNeeds.tableReadOnly')}</Text>
                <div>
                  <StyledHeading level={5}>
                    {t('skillsAndNeeds.tableReadOnlyDescription')}
                  </StyledHeading>
                  <StyledLink level={5}>
                    <a
                      href="https://support.logmycare.co.uk/en/articles/6987442-how-to-set-up-skills-for-your-service"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={styles.link}
                    >
                      {t('skillsAndNeeds.tableReadOnlyLink')}
                    </a>
                  </StyledLink>
                </div>
              </div>
            }
          >
            {renderButton}
          </Popover>
        ) : (
          renderButton
        )
      }
    />
  )
}

const styles = {
  logoIcon: {
    width: 26,
    height: 26,
  },
  linkWrapper: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 257,
  },
  headingWrapper: {
    display: 'flex',
    flexDirection: 'row',
  },
  link: { color: 'black', textDecoration: 'underline' },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
}

export default SkillNeedTemplateHeaderSection
